<template>
  <!-- Modal -->
  <Modal :showModal="isModalOpen" @close="closeModal">
    <template #header>
      <h5>{{ modalTitle }}</h5>
    </template>
    <template #body>
      <img class="modal__img" :src="modalContent" />
    </template>
  </Modal>

  <!-- Content -->
  <h2>Registro de Parámetros Atmosféricos</h2>
  <div class="cards">
    <div v-for="variable in variables" :key="variable.name" class="card">
      <div class="card__title">
        {{ variable.name }}
      </div>
      <div class="card__img">
        <img
          v-on:click="openModal(variable.url, variable.name)"
          :src="variable.url"
          :title="variable.name"
          :alt="variable.name"
          :onerror="
            `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
          "
          :broken="
            `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
          "
        />
      </div>
    </div>
  </div>
</template>
<script>
import Modal from "@/components/common/Modal.vue";
export default {
  components: {
    Modal,
  },
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    const basePath_images = process.env.VUE_APP_TEST_IMAGE;
    const currentDate = new Date().getTime();
    return {
      basePath,
      basePath_images,
      currentDate,
    };
  },
  data() {
    return {
      modalTitle: "",
      modalContent: "",
      isModalOpen: false,
      image: null,
      variables: [
        {
          name: "Temperatura del aire",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Tair.png",
        },
        {
          name: "Temperatura del Suelo",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/Tsfc.png",
        },
        {
          name: "Humedad atmosférica",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/HR.png",
        },
        {
          name: "Precipitación (Pluviómetro)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/PP.png",
        },
        {
          name: "Precipitación (Distrómetro)",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/PPD.png",
        },
        {
          name: "Radiación Infraroja",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/IR.png",
        },
      ],
    };
  },
  methods: {
    openModal(img, title) {
      this.modalTitle = title;
      this.modalContent = img;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.image-background {
  display: flex;
  justify-content: center;
}
img {
  cursor: pointer;
}
.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
}

@media (max-width: 768px) {
  .cards {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

.card {
  border: 1px solid #ccc;
  border-radius: 5px;
}

.card__title {
  background-color: #0099ff;
  color: white;
  padding: 0.5em;
  text-align: center;
}

.card__btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0099ff;
  color: white;
  border-radius: 100%;
  opacity: 0.5;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.card__img {
  overflow: hidden;
}
.card__img > img:hover {
  scale: 105%;
  transition-duration: 200ms;
  transition-property: scale;
  transition-timing-function: ease-in-out;
}

.card__content > p {
  padding: 0.5em;
}

.modal__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
</style>
